import React from 'react';

const SvgTagTypes = props => (
  <svg width={'100%'} viewBox="0 0 32 32" {...props}>
    <defs>
      <style>
        {'.tag_types_svg__a{fill:none;stroke:#acacac;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}'}
      </style>
    </defs>
    <path
      className="tag_types__a"
      style={{ stroke: props.color, fill: 'none', strokeWidth: props.stroke || 2 }}
      d="M18.6 3A10.4 10.4 0 0129 13.4"
    />
    <path fill="none" d="M0 0h32v32H0z" />
    <path
      className="tag_types__a"
      style={{ stroke: props.color, fill: 'none', strokeWidth: props.stroke || 2 }}
      d="M22 17v9a2 2 0 01-2 2H6a2 2 0 01-2-2V12a2 2 0 012-2h9M19 8a5 5 0 015 5M19 13"
    />
  </svg>
);

export default SvgTagTypes;
